import React, { FC } from 'react'
import { FixedLayout } from 'components/Layout'
import { RegisterCompleteTemplate } from 'components/Templates'
import { useSelector } from 'react-redux'
import { State } from 'index'

const RegisterComplete: FC = () => {
  const query = useSelector((state: State) => state.router.location.query)
  const type = query.type
  const headline = (() => {
    switch (type) {
      case 'create':
        return 'アカウントの登録が\n完了しました'
      case 'update':
        return 'アカウントの紐付けが\n完了しました'
      default:
        return 'アカウントの紐付けが\n完了しました'
    }
  })()
  return (
    <FixedLayout title={'アカウント登録完了'}>
      <RegisterCompleteTemplate headline={headline} />
    </FixedLayout>
  )
}

export default RegisterComplete
